export const ITEM_MAINTENANCE_LOADING = 'ITEM_MAINTENANCE_LOADING';
export const ALTERNATIVE_ITEMS = 'ALTERNATIVE_ITEMS';
export const ON_HAND_ITEMS = 'ON_HAND_ITEMS';
export const BID_PRICE_DATA = 'BID_PRICE_DATA';
export const BID_PRICE_LOADING = 'BID_PRICE_LOADING';
export const ON_HAND_ITEMS_LOADING = 'ON_HAND_ITEMS_LOADING';
export const SUBMITTING_ITEM_DETAIL = 'SUBMITTING_ITEM_DETAIL';
export const SUBMIT_ITEM_DETAIL_ERROR = 'SUBMIT_ITEM_DETAIL_ERROR';
export const ITEM_DETAIL_SUBMIT = 'ITEM_DETAIL_SUBMIT';
export const CLEAR_ITEM_ERROR = 'CLEAR_ITEM_ERROR';
export const FIFO_ITEMS = 'FIFO_ITEMS';
export const TRANSACTION_DETAILS_DATA = 'TRANSACTION_DETAILS_DATA';
export const TRANSACTION_DETAILS_LOADING = 'TRANSACTION_DETAILS_LOADING';
export const FETCH_BID_PRICE_ERROR = 'FETCH_BID_PRICE_ERROR';
export const FETCH_ON_HANDS_ERROR = 'FETCH_ON_HANDS_ERROR';
export const FETCH_TRANSACTION_ERROR = 'FETCH_TRANSACTION_ERROR';
export const ALTERNATIVE_ITEMS_ERROR = 'ALTERNATIVE_ITEMS_ERROR';
export const FETCH_FIFO_ITEMS_ERROR = 'FETCH_FIFO_ITEMS_ERROR';
export const FIFO_LOADING = 'FIFO_LOADING';
export const PRINT_REPORT_LOADING = 'PRINT_REPORT_LOADING';
export const PRINT_REPORT_ERROR = 'PRINT_REPORT_ERROR';
export const GET_REPORT = 'GET_REPORT';
export const CLEAR_REPORT = 'CLEAR_REPORT';



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/addEditItem/types.js